import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@mui/styles';
import { ClassNameMap, Typography } from '@mui/material';

type styleProps = {
  classes?: ClassNameMap;
  color: string;
  labelColor: string;
  borderColor: string;
  borderStyle: string;
};

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    padding: theme.spacing(0, 0, 0, 1)
  },
  rootLegend: {
    display: 'flex',
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
    alignSelf: 'center',
    border: ({ borderColor, borderStyle }: styleProps) =>
      `1px ${borderStyle} ${borderColor} `
  },
  legendText: {
    ...theme.typography.caption,
    padding: theme.spacing(0, 0, 0, 1)
  },
  legendBackgroundColor: {
    backgroundColor: ({ color }: styleProps) => color
  },
  legendFontColor: {
    color: theme.palette.text.primary
  }
}));

type LegendProp = {
  classes?: ClassNameMap;
  label: string;
  color: string;
  labelColor: string;
  borderColor: string;
  borderStyle: string;
};
export const Legend: React.FC<LegendProp> = ({
  classes: classesOverride,
  label,
  color,
  labelColor,
  borderColor,
  borderStyle = 'solid'
}: LegendProp) => {
  const classes = useStyles({
    classes: classesOverride,
    color,
    labelColor,
    borderColor,
    borderStyle
  });

  return (
    <div className={classes.container} data-testid={`legend_text_${label}`}>
      <span
        className={classNames(
          classes.rootLegend,
          classes.legendBackgroundColor
        )}
      />
      <Typography
        className={classNames(classes.legendText, classes.legendFontColor)}
        data-testid="legend-label"
      >
        {label}
      </Typography>
    </div>
  );
};
